import { render, staticRenderFns } from "./product-form-v2.modal.vue?vue&type=template&id=2d56afa1&scoped=true"
import script from "./product-form-v2.modal.vue?vue&type=script&lang=js"
export * from "./product-form-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./product-form-v2.modal.vue?vue&type=style&index=0&id=2d56afa1&prod&lang=scss&scoped=true"
import style1 from "./product-form-v2.modal.vue?vue&type=style&index=1&id=2d56afa1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56afa1",
  null
  
)

export default component.exports